exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.image[data-v-3414c030] {\n  width: 215px;\n  display: block;\n  background-repeat: no-repeat;\n  margin-right: auto;\n  margin-left: auto;\n}\n", "", {"version":3,"sources":["/home/vvikas-fedora-hp/dev/hellopeter/portal/src/widgets/ReviewQRCodesWidget.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;CACnB","file":"ReviewQRCodesWidget.vue","sourcesContent":["\n.image[data-v-3414c030] {\n  width: 215px;\n  display: block;\n  background-repeat: no-repeat;\n  margin-right: auto;\n  margin-left: auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3414c030","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/widgets/ReviewQRCodesWidget.vue
// module id = f+jB
// module chunks = 4